import { useQuery, UseQueryResult } from "@tanstack/react-query";
import axios, { AxiosResponse } from "axios";
import { useTranslation } from "react-i18next";
import { Publication, ResearchArea } from "../DTOs/responses/research";

export const useResearchAreas = (): UseQueryResult<ResearchArea[]> => {
  const { i18n } = useTranslation();
  const language = i18n.language;

  const fetchResearchAreas = (): Promise<AxiosResponse<ResearchArea[]>> => {
    const headers = {
      Accept: "*/*",
      "Accept-Language": language,
    };

    return axios.get(`${process.env.REACT_APP_BASE_URL}/research`, {
      headers,
    });
  };

  return useQuery({
    refetchOnWindowFocus: false,
    queryKey: ["research-areas-get", language],
    queryFn: fetchResearchAreas,
    select: (data) => data.data,
  });
};

// Citations are language-neutral, so this one is not keyed by language.
export const usePublications = (): UseQueryResult<Publication[]> => {
  const fetchPublications = (): Promise<AxiosResponse<Publication[]>> =>
    axios.get(`${process.env.REACT_APP_BASE_URL}/research/publications`, {
      headers: { Accept: "*/*" },
    });

  return useQuery({
    refetchOnWindowFocus: false,
    queryKey: ["publications-get"],
    queryFn: fetchPublications,
    select: (data) => data.data,
  });
};
